import React, { useCallback } from 'react';
import {    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Edit, SimpleForm, TextInput,SelectInput,
    DateInput, BooleanInput, NumberInput,ReferenceInput,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton,AutocompleteInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { makeStyles } from '@material-ui/core/styles';
import { CreateToolbar } from "../../CreateToolbar";

const useStyles = makeStyles(theme => ({
    subjectid:{
        display:'inline-block'
    }, 
    title: {
        display:'inline-block',
        marginLeft: '20px',
        width:'300px'
    }
}));

export const WorkRolesEdit = props => {
    const classes = useStyles({});
    return (
        <Edit {...props}>
            <SimpleForm redirect="list"   toolbar={<CreateToolbar {...props} />}
            variant="outlined">
            <TextInput source="name" label="Project Name"/>
            <TextInput source="description" label="BU"/>
            <ReferenceInput perPage={5000} source="departmentId" reference="departments"
            filterToQuery={searchText => ({ 'name~like': searchText })}
            sort={{ field: 'name', order: 'ASC' }} 
            >
            <AutocompleteInput  variant="outlined" 
                optionText={choice => {
                    return (choice?.name) ;
                }
                }
            />
                </ReferenceInput>
            </SimpleForm>
        </Edit>
    );
}